<template>
  <div>
    <transition name="slide-fade" appear>
      <b-row>
        <b-col cols="lg-8 md-10">
          <b-card title="Datos del Estudiante">
            <b-row class="mt-4">
              <b-col cols="md-3" class="mb-3">
                <b-img :src="$store.state.fotoUsuario" rounded="circle" width="80px"/>
              </b-col>
              <b-col cols="md-9">
                <span>Nombres y Apellidos:<br><strong>{{this.$store.state.nombresUsuario}}</strong> {{this.$store.state.apellidosUsuario}}</span><br><br>
                <span>{{this.$store.state.tipoDocumentoUsuario}}:<br>No.: <strong>{{this.$store.state.documentoUsuario}}</strong></span><br><br>
                <span>Fecha de Nacimiento:<br><strong>{{this.$store.state.fechaNacimientoUsuario.slice(0,10)}}</strong></span><br><br>
                <span>Genero:<br><strong>{{this.$store.state.generoUsuario}}</strong></span><br><br>
                <span>Factor Rh:<br><strong>{{this.$store.state.rhUsuario}}</strong></span><br><br>
                <span>Dirección Domicilio:<br><strong>{{this.$store.state.direccionUsuario}}</strong></span><br><br>
                <span>Teléfono de Contacto:<br><strong>{{this.$store.state.telefonoUsuario}}</strong></span><br><br>
                <span>Correo Electrónico:<br><strong>{{this.$store.state.correoUsuario}}</strong></span><br><br>
                <span>Última Actualización:<br><strong>{{this.fechaActualizacion}}</strong></span><br><br>
                <p class="text-right"><b-button variant="link" class="">Editar perfil</b-button></p>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      
    </transition>
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
  },
  data () {
    return {
      fechaActualizacion: ''
    }
  },
  methods: {
    cargaDatosUsuario() {
      this.fechaActualizacion = new Date(this.$store.state.fechaActualizacionFichaUsuario)
      this.fechaActualizacion = this.fechaActualizacion.toLocaleDateString() + ' a las ' + this.fechaActualizacion.toLocaleTimeString()
    }
  },
  beforeMount() {
    this.cargaDatosUsuario()
  }
}
</script>
